export const CART_STATE = {
  CONFIRMATION_REQUIRED: 'CONFIRMATION_REQUIRED',
  BLOCKED: 'BLOCKED',
  OK: 'OK',
}

export const CART_STATE_REASON = {
  TRADE_LIMIT_USED: 'TRADE_LIMIT_USED',
  CART_LIMIT_EXCEEDED: 'CART_LIMIT_EXCEEDED',
  OVERDUE_INVOICES: 'OVERDUE_INVOICES',
}
